import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (consumidores/specs antigos importavam estes nomes). */
export type CertidaoInscricaoMedicoJob = ReportJob;
export type CertidaoInscricaoMedicoJobStatus = JobStatus;

@Injectable({ providedIn: 'root' })
export class CertidaoInscricaoMedicoJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'certidao-inscricao-medico-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.medico.reports.certidaoInscricaoMedico;
}
